import * as React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import { useRef } from 'react';
import { updateOrder } from '../api/rest';
import { getFormValues } from '../util/forms';
import DefaultFormMap from '../components/DefaultFormMap';
import { stateEnums } from './Enums';

const ShippingTab = ({ authorization, order, wrapAPIAction }) => {
    const form = useRef(null);
    const disabled = authorization == undefined || authorization.type != "administrator";

    const items = [
        { name: "shippingAddress", label: 'Shipping Address', defaultValue: order.orderInfo.shipping.address, disabled },
        { name: "shippingSuburb", label: 'Suburb', defaultValue: order.orderInfo.shipping.suburb, disabled },
        { name: 'shippingPostCode', label: "Postcode", defaultValue: order.orderInfo.shipping.postcode, disabled },
        {
            name: 'shippingState', label: "State", defaultValue: order.orderInfo.shipping.state, disabled, options: stateEnums.map((option) => (
                <MenuItem key={option.key} value={option.value}>
                    {option.value}
                </MenuItem>
            ))
        }
    ]
    return <Box>
        <DefaultFormMap form={form} items={items} />
        {!disabled && <Button sx={{ mt: 1 }} variant="outlined" onClick={() => wrapAPIAction(async () => updateOrder({ authorization, orderId: order._id, formValues: getFormValues(form) }))}>Save Changes</Button>}
    </Box>
}

export default ShippingTab